document.addEventListener('DOMContentLoaded', function () {
  const DESKTOP_BP = 1200;
  const HEADER_OFFSET = 120;
  const SCROLL_OFFSET = 300;

  const toc = document.querySelector('#rank-math-toc');
  if (!toc) return;

  const parentElm = toc.querySelector('nav > ol') || toc.querySelector('nav > ul');
  const translations = window.livecareerTranslations?.strings;
  const contElm = document.querySelector('.blogMain');

  // Inject "Introduction" link at top of TOC list
  if (document.body.classList.contains('lc-uk')) {
    parentElm.insertAdjacentHTML('afterbegin', `<li class="active"><a class="active" href="#intro-content">Introduction</a></li>`);
    contElm.insertAdjacentHTML('afterbegin', '<span id="intro-content"></span>');
  }else if(document.body.classList.contains('lc-fr')) {
    parentElm.insertAdjacentHTML("afterbegin", '<li class="active"><a class="active" href="#intro">Introduction</a></li>');
    contElm.insertAdjacentHTML("afterbegin", '<span id="intro"></span>');
  }else if(document.body.classList.contains('lc-de')){
    parentElm.insertAdjacentHTML("afterbegin", '<li class="active"><a class="active" href="#intro">Einleitung</a></li>');
    contElm.insertAdjacentHTML("afterbegin", '<span id="intro"></span>');
  }else if(document.body.classList.contains('lc-br')) {
    parentElm.insertAdjacentHTML("afterbegin", '<li class="active"><a class="active" href="#intro">Introdução</a></li>');
    contElm.insertAdjacentHTML("afterbegin", '<span id="intro"></span>');
  }else if(document.body.classList.contains('lc-es')) {
    parentElm.insertAdjacentHTML("afterbegin", '<li class="active"><a class="active" href="#intro-content">Introducción</a></li>');
    contElm.insertAdjacentHTML("afterbegin", '<span id="intro-content"></span>');
  }else if(document.body.classList.contains('lc-it')) {
    parentElm.insertAdjacentHTML("afterbegin", '<li class="active"><a class="active" href="#intro-content">Introduzione</a></li>');
    contElm.insertAdjacentHTML("afterbegin", '<span id="intro-content"></span>');
  }else{
    parentElm.insertAdjacentHTML("afterbegin", '<li class="active"><a class="active" href="#intro-content">Wstęp</a></li>');
    contElm.insertAdjacentHTML("afterbegin", '<span id="intro-content"></span>');

  }

  // Set up toggle & label for each TOC block
  document.querySelectorAll('.js-toc').forEach((tocBlock) => {
    const title = tocBlock.querySelector('p');
    if (title && translations?.table_of_contents) {
      title.textContent = translations.table_of_contents;
    }

    if (title && tocBlock.querySelector('nav')) {
      title.addEventListener('click', (e) => {
        e.stopPropagation();
        tocBlock.classList.toggle('open');
      });
    }
  });

  // // Close TOC when clicking outside
  // document.addEventListener('click', (e) => {
  //   if (!e.target.closest('.js-toc')) {
  //     document.querySelectorAll('.js-toc.open').forEach((el) => el.classList.remove('open'));
  //   }
  // });

  initTocScroll(DESKTOP_BP, HEADER_OFFSET);
  initRailCtaVisibility();
});

function initTocScroll(desktopBp, headerOffset) {
  const tocLinks = document.querySelectorAll('#rank-math-toc nav a');
  if (!tocLinks.length) return;

  const tocSections = Array.from(tocLinks)
    .map((link) => document.getElementById(link.getAttribute('href').substring(1)))
    .filter(Boolean);

  function activateLink(targetId) {
    tocLinks.forEach((link) => {
      const isMatch = link.getAttribute('href') === `#${targetId}`;
      link.classList.toggle('active', isMatch);
      link.parentElement?.classList.toggle('active', isMatch);
    });
  }

  tocLinks.forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const targetId = this.getAttribute('href').substring(1);
      const target = document.getElementById(targetId);
      if (target) {
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.pageYOffset - headerOffset,
          behavior: 'smooth',
        });
      }

      activateLink(targetId);
    });
  });

  // Scroll-based active link tracking (desktop only)
  if (window.innerWidth >= desktopBp) {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.find((entry) => entry.isIntersecting);
        if (visible) activateLink(visible.target.id);
      },
      { rootMargin: '0px 0px -60% 0px', threshold: 0.3 }
    );

    setTimeout(() => tocSections.forEach((s) => observer.observe(s)), 2000);
  }
}

function initRailCtaVisibility() {
  const railCta = document.querySelector('.railCta');
  const tocEl = document.querySelector('.js-toc');
  const tocWrapper = document.querySelector('.toc-wrapper');
  if (!railCta) return;

  // Threshold = scroll position at which .toc-wrapper goes sticky:
  // its natural document top minus the CSS sticky top offset (4.8rem = 48px)
  const tocTopAbs = tocEl ? tocEl.getBoundingClientRect().top + window.pageYOffset : 0;
  const stickyOffset = tocWrapper ? (parseFloat(getComputedStyle(tocWrapper).top) || 0) : 0;
  const threshold = tocTopAbs - stickyOffset;

  const update = () => {
    const past = window.pageYOffset > threshold;
    railCta.classList.toggle('ctaHidden', !past);
    railCta.classList.toggle('ctaVisible', past);
    if (tocEl) tocEl.classList.toggle('ctaVisible', past);
  };

  window.addEventListener('scroll', update, { passive: true });
  update();
}
